export default "__VITE_ASSET__C$VqysWv__"